import adminApi from "./adminApi";

export async function executeAdminScript(
  scriptPath,
  database
) {

  const baseUrl =
    database === "test"
      ? "https://api2.visionroyale.com"
      : "https://api.visionroyale.com";


  const response = await adminApi.get(
    `${baseUrl}${scriptPath}`,
    {
      headers: {
        key: process.env.REACT_APP_ACCESKEY,
      },
    }
  );


  return response.data;
}